export default __webpack_public_path__ + "static/media/background-ground.67afb477.svg";